<template>
  <div class="home">
    <!-- <div class="bg_black text_white">
      <div class="ninew bodybox"> -->
    <van-nav-bar :border="false" fixed :title="$t('center.title')">
      <span slot="right" @click="logout()" style="font-size: 15px">{{
        $t("center.logout")
      }}</span>
    </van-nav-bar>
    <!-- <div class="null"></div> -->
    <!-- </div>
    </div> -->
    <div class="ninew bodybox">
      <div class="main">
        <!-- 	<van-image
				class="minebg"
			  	width="100%"
			  	fit='contain'
			  	src="./static/img/bj.png"/> -->
        <div class="user">
          <span class="IDtext" style="height: 35px"
            >ID:{{ userInfo.account }}</span
          >
          <!-- <span style="height: 18px;">{{userInfo.name}}</span> -->
          <div class="userInfo">
            <div class="coin fl" @click="$router.push('/ShopList')">
              <div class="row1">
                <div>
                  <img
                    src="../../static/img/boss_shop1.png"
                    alt=""
                    class="shop"
                  />
                </div>
              </div>
              <div class="coinDetail">
                <span>{{ $t("center.coinDetail") }}</span>
              </div>
            </div>
            <div class="coin fl" @click="$router.push('/ServiceBill')">
              <div class="row1">
                <div>
                  <img
                    src="../../static/img/boss_bill.png"
                    alt=""
                    class="bill"
                  />
                </div>
              </div>
              <div class="coinDetail">
                <span>{{ $t("center.coinDetail1") }}</span>
              </div>
            </div>
            <div class="coin fr">
              <div class="coinTitle">{{ $t("center.coinTitle") }}</div>
              <div class="coinDetail">
                <span v-if="userInfo.coins">{{ userInfo.coins }}</span>
                <span v-else>0.0</span>
              </div>
              <div class="coinDetail">
                <button class="recharge" @click="$router.push('/ContactUs')">
                  {{ $t("center.recharge") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-cell-group>
        <van-cell
          icon="./static/img/service.png"
          :title="$t('center.cusservice')"
          is-link
          to="/ContactUs"
        />
        <van-cell
          icon="./static/img/iphone_num.png"
          :title="$t('center.relativePhone')"
          is-link
          to="/checkNum"
        />
        <!-- checkNum -->
        <van-cell
          icon="./static/img/jieshaoren.png"
          :title="$t('center.myintroPeople')"
          is-link
          to="/MyIntro"
        />
        <van-cell
          icon="./static/img/kehu.png"
          :title="$t('center.myClient')"
          is-link
          to="/MyClient"
        />
        <!-- <van-cell
        icon="./static/img/kehu.png"
        :title="$t('center.platformList')"
        is-link
        to="/PlatformList"
      />
      <van-cell
        icon="./static/img/kehu.png"
        :title="$t('center.platformInfo')"
        is-link
        to="/PlatformInfo"
      /> -->
        <van-cell
          icon="./static/img/yuyan.png"
          :title="$t('center.chooseL')"
          :value="lang"
          is-link
          @click="showLanguage = true"
        />
      </van-cell-group>
      <div class="bottomTip">{{ $t("center.tip") }}</div>
      <!-- <van-field :label="$t('center.chooseL')" 
					readonly
					left-icon="./static/img/yuyan.png"
					@click='showLanguage=true' :placeholder="$t('center.chooseLang')" v-model='lang' is-link></van-field> -->
      <van-popup v-model="showLanguage" position="bottom">
        <van-picker
          show-toolbar
          :columns="language"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
          @cancel="showLanguage = false"
          @confirm="onConfirm"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      showLanguage: false,
      language: ["简体中文", "繁體中文", "English"],
      lang: "",
      changeLocale: ""
    };
  },
  mounted: function() {
    this.getUserInfo();
    this.getLangsVal();
    this.changeLocale = localStorage.getItem("bgLangsVal") || "en";
    console.log(this.changeLocale);
    this.changeLang();
  },
  methods: {
    getUserInfo() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/user/member",
        withCredentials: true,
        crossDomain: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == 200) {
            this.userInfo = res.data.data;
            sessionStorage.setItem("telphone", res.data.data.phone);
            sessionStorage.setItem("coins", res.data.data.coins);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("center.message")
          });
        });
    },
    logout() {
      this.$dialog
        .confirm({
          title: this.$t("center.back"),
          message: this.$t("center.isBack"),
          confirmButtonColor: "#2f75f4",
          confirmButtonText: this.$t("vantText.confirm"),
          cancelButtonText: this.$t("vantText.cancel")
        })
        .then(() => {
          // sessionStorage.clear();
          this.$router.push("/");
        })
        .catch(() => {});
    },

    //多语言选择
    onConfirm(value) {
      this.showLanguage = false;
      this.lang = value;
      if (value == "简体中文") {
        this.$i18n.locale = "zh";
        localStorage.setItem("langs", "zh"); //在main.js中用到
        this.changeLocale = "zh_cn"; //后台接口
      } else if (value == "繁體中文") {
        this.$i18n.locale = "hk";
        localStorage.setItem("langs", "hk");
        this.changeLocale = "zh_hk";
      } else if (value == "English") {
        this.$i18n.locale = "en";
        localStorage.setItem("langs", "en");
        this.changeLocale = "en";
      }
      localStorage.setItem("bgLangsVal", this.changeLocale);
      this.changeLang();
    },

    changeLang() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/changeLocale/" + this.changeLocale,
        withCredentials: true,
        crossDomain: true
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    getLangsVal() {
      if (this.$i18n.locale == "zh") {
        this.lang = "简体中文";
      } else if (this.$i18n.locale == "hk") {
        this.lang = "繁體中文";
      } else if (this.$i18n.locale == "en") {
        this.lang = "English";
      }
    }
  }
};
</script>
<style scoped>
.home {
  width: 100%;
  /* height: 100vh; */
}

/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field .van-icon {
  font-size: 26px;
}
/deep/ .van-uploader__input-wrapper > i {
  font-size: 26px;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f7;
}
/deep/ .van-cell__value {
  color: #000;
}
.van-cell-group {
  margin-top: -5px;
}
.main {
  width: 100%;
  min-height: 230px;
  position: relative;
  overflow: hidden;
  margin-top: 0px;
}
.minebg {
  position: absolute;
  z-index: 1;
}
.user {
  position: absolute;
  width: 100%;
  height: 220px;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #000;
}
.user > span {
  margin: 5px;
  color: #fff;
}
.userImg {
  width: 100%;
  height: 100px;
  text-align: center;
  position: relative;
  margin-top: 5px;
}
.upload {
  position: absolute;
  left: 50%;
  margin-left: 20px;
  bottom: 0;
  font-size: 24px;
}
.userInfo {
  width: 90%;
}
.coin {
  width: 30%;
  display: inline-block;
  border-radius: 10px;
  height: 120px;
  margin-right: 5%;
  background: #fff;
}
.userInfo .coin:last-child {
  margin: 0;
}
.recharge {
  height: 35px;
  font-size: 14px;
  line-height: 35px;
  background: #2f54eb;
  padding: 0 8px;
  border-radius: 12px;
  outline: none;
  border: none;
  color: #fff;
  border-radius: 20px;
  display: block;
  margin: 0 auto;
}
.coinTitle {
  width: 100%;
  height: 35px;
  line-height: 35px;
  text-align: center;
  color: #000;
  margin-top: 5px;
}
.coinDetail {
  width: 100%;
  line-height: 30px;
}
.coinDetail > span {
  color: #333;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  display: inline-block;
  width: 100%;
}
.shop {
  width: 50px;
  height: 50px;
  vertical-align: middle;
  padding-right: 5px;
}
.bill {
  width: 50px;
  height: 50px;
  vertical-align: middle;
  padding-right: 5px;
}
.row1 {
  display: flex;
  justify-content: center;
  margin: 10px;
}
.row1 span {
  font-size: 15px;
}
.bottomTip {
  color: #666;
  font-size: 12px;
  padding: 5px 16px;
}
</style>



// WEBPACK FOOTER //
// src/Person/Center.vue